import React from 'react';

import { FormControl, Grid, InputLabel, Select, MenuItem } from '@mui/material';
import { useApiGet } from '../../utils/httpClient';
import { getAllReports } from '../../endpoints/reportsTs';

export default function DocumentCategorySelector({
  category,
  handleCategorySelect,
}) {
  const { data } = useApiGet(['doc-cat-selector'], getAllReports, {
    enabled: true,
    retry: 1,
  });

  const reports = Array.isArray(data) ? data : [];

  return (
    <Grid container>
      <Grid item xs={12}>
        {reports.length > 0 && (
          <FormControl fullWidth>
            <InputLabel id="doc-cat-label">Category</InputLabel>
            <Select
              labelId="doc-cat-label"
              id="doc-cat-select"
              value={category}
              label="Category"
              onChange={(event) => handleCategorySelect(event.target.value)}
            >
              {reports.map((docCat) => (
                <MenuItem key={docCat.id} value={docCat.id}>
                  {docCat.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </Grid>
    </Grid>
  );
}
